const OIDC = 'auth-events-broadcast';

export const OIDCChanel = new BroadcastChannel(OIDC);

export const BROADCAST_PAYLOADS = {
  OIDC: {
    logout: { type: 'logout' },
    updateUser: { type: 'updateUser' },
  },
};
